import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export const CaseStudiesSection = () => {
  return <section id="case-studies" className="py-16 bg-light" data-id="element-114">
      <div className="container mx-auto px-4 md:px-8" data-id="element-115">
        <div className="text-center mb-12" data-id="element-116">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4" data-id="element-117">
            See Some Real Life Client Case Studies From Working With Us
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-118">
            Discover how our clients have achieved exceptional returns on their
            Dubai property investments
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 mt-12" data-id="element-119">
          {/* Case Study 1 */}
          <div className="bg-white rounded-lg shadow-xl overflow-hidden transition-transform hover:scale-[1.02] duration-300" data-id="element-120">
            <div className="relative h-64" data-id="element-121">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/94GGQ55LRVnoWAW63jNYrM/pasted-image.jpg" alt="Alandalus Apartment" className="w-full h-full object-cover" data-id="element-122" />
              <div className="absolute top-4 right-4 bg-primary text-white py-1 px-3 rounded-full font-medium" data-id="element-123">
                Case Study 1
              </div>
            </div>
            <div className="p-6" data-id="element-124">
              <h3 className="text-xl font-display font-bold mb-4" data-id="element-125">
                Jumeirah Golf Estates Investment
              </h3>
              <div className="space-y-3 mb-6" data-id="element-126">
                <div className="flex items-start" data-id="element-127">
                  <ChevronRightIcon size={20} className="text-accent mt-1 mr-2 flex-shrink-0" data-id="element-128" />
                  <p className="text-gray-700" data-id="element-129">
                    <span className="font-semibold" data-id="element-130">Property:</span> 1 bedroom
                    apartment in Alandalus, Jumeirah Golf Estates
                  </p>
                </div>
                <div className="flex items-start" data-id="element-131">
                  <ChevronRightIcon size={20} className="text-accent mt-1 mr-2 flex-shrink-0" data-id="element-132" />
                  <p className="text-gray-700" data-id="element-133">
                    <span className="font-semibold" data-id="element-134">Purchase (2019):</span> AED
                    725,000 + AED 29,000 DLD fees
                  </p>
                </div>
                <div className="flex items-start" data-id="element-135">
                  <ChevronRightIcon size={20} className="text-accent mt-1 mr-2 flex-shrink-0" data-id="element-136" />
                  <p className="text-gray-700" data-id="element-137">
                    <span className="font-semibold" data-id="element-138">Sale (2025):</span> AED
                    1,260,000
                  </p>
                </div>
                <div className="flex items-start" data-id="element-139">
                  <ChevronRightIcon size={20} className="text-accent mt-1 mr-2 flex-shrink-0" data-id="element-140" />
                  <p className="text-gray-700" data-id="element-141">
                    <span className="font-semibold" data-id="element-142">Return on Equity:</span> 67%
                    over 6 years (10%+ annual capital gain)
                  </p>
                </div>
              </div>
              <div className="bg-light p-4 rounded-lg" data-id="element-143">
                <p className="font-semibold text-primary" data-id="element-144">
                  MRM's investment in an off-plan apartment yielded a 67% return
                  in just 6 years, demonstrating the strong growth potential in
                  Dubai's premium residential market.
                </p>
              </div>
            </div>
          </div>
          {/* Case Study 2 */}
          <div className="bg-white rounded-lg shadow-xl overflow-hidden transition-transform hover:scale-[1.02] duration-300" data-id="element-145">
            <div className="relative h-64" data-id="element-146">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/tFZumdj7UQHkNoeawfsPB7/pasted-image.jpg" alt="Green Community Villa" className="w-full h-full object-cover" data-id="element-147" />
              <div className="absolute top-4 right-4 bg-primary text-white py-1 px-3 rounded-full font-medium" data-id="element-148">
                Case Study 2
              </div>
            </div>
            <div className="p-6" data-id="element-149">
              <h3 className="text-xl font-display font-bold mb-4" data-id="element-150">
                Green Community Long-Term Investment
              </h3>
              <div className="space-y-3 mb-6" data-id="element-151">
                <div className="flex items-start" data-id="element-152">
                  <ChevronRightIcon size={20} className="text-accent mt-1 mr-2 flex-shrink-0" data-id="element-153" />
                  <p className="text-gray-700" data-id="element-154">
                    <span className="font-semibold" data-id="element-155">Property:</span> 4 bedroom
                    villa in Green Community, DIP1
                  </p>
                </div>
                <div className="flex items-start" data-id="element-156">
                  <ChevronRightIcon size={20} className="text-accent mt-1 mr-2 flex-shrink-0" data-id="element-157" />
                  <p className="text-gray-700" data-id="element-158">
                    <span className="font-semibold" data-id="element-159">Purchase (2009):</span> AED
                    2,500,000 + AED 80,000 transfer charges
                  </p>
                </div>
                <div className="flex items-start" data-id="element-160">
                  <ChevronRightIcon size={20} className="text-accent mt-1 mr-2 flex-shrink-0" data-id="element-161" />
                  <p className="text-gray-700" data-id="element-162">
                    <span className="font-semibold" data-id="element-163">Sale (2025):</span> AED
                    6,250,000
                  </p>
                </div>
                <div className="flex items-start" data-id="element-164">
                  <ChevronRightIcon size={20} className="text-accent mt-1 mr-2 flex-shrink-0" data-id="element-165" />
                  <p className="text-gray-700" data-id="element-166">
                    <span className="font-semibold" data-id="element-167">Return on Equity:</span>{' '}
                    142% over 16 years (approximately 9% annually)
                  </p>
                </div>
              </div>
              <div className="bg-light p-4 rounded-lg" data-id="element-168">
                <p className="font-semibold text-primary" data-id="element-169">
                  SA's villa investment showcases the long-term stability and
                  growth of Dubai's premium real estate market, with a 142%
                  return over 16 years.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};